import { createAbacLoader } from "./abac.loader";
import { createAuthLoader } from "./auth.loader";
import { combineLoaders } from "./composite.loader";

/**
 * Pre-configured loader combining:
 * - Authentication check (redirects to /welcome if not logged)
 * - ABAC check for "update" permission on "Account" model
 *
 * Use this loader for routes that require an authenticated user
 * with Account update permissions (settings, profile editing, etc.)
 */
export function createAccountUpdateLoader() {
  const authLoader = createAuthLoader();
  const abacLoader = createAbacLoader({ permission: { can: "update", model: "Account" } });
  return combineLoaders(authLoader, abacLoader);
}

export const accountUpdateLoader = createAccountUpdateLoader();
